import { Component, OnInit } from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'app-programmes',
  templateUrl: './programmes.component.html',
  styleUrls: ['./programmes.component.scss']
})
export class ProgrammesComponent implements OnInit {

  constructor( private meta: Meta,
               private titles: Title) { }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('ARNI Programmes – Explore Our Courses & Programs');
        this.meta.updateTag({
            name: 'description',
            content: `Discover ARNI’s wide range of programs and courses designed to provide quality education and prepare students for success in their chosen fields.`
        });
    }

}
